import { useEffect, useRef } from "react";
import { copyText1 } from "../utils/constants";
import { useTranslation } from "react-i18next";

// Подмена буфера при копировании ссылки-приглашения: к ссылке дописывается текст.
// 10.10: ссылка и ключ текста читаются через ref на момент копирования. Раньше
// слушатель запоминал значения первого рендера (эффект с []), а ссылка часто
// приходит позже (асинхронно) — в буфер уходил текст без ссылки или чужая ссылка.
export default function useMutateCopyData(inviteLink, text2Key) {
  const { t } = useTranslation();
  const latest = useRef({ inviteLink, text2Key, t });
  latest.current = { inviteLink, text2Key, t };

  useEffect(() => {
    const onMutateCopyData = (e) => {
      const { inviteLink: link, text2Key: key, t: tr } = latest.current;
      e.clipboardData.setData(
        "text/plain",
        `${tr(copyText1)}
${tr(key)}
${link}`
      );
      e.preventDefault();
    };
    document.addEventListener("copy", onMutateCopyData);
    return () => {
      document.removeEventListener("copy", onMutateCopyData);
    };
  }, []);
}
